import { Grid, Paper, Typography, useTheme, PaletteMode } from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";
import "./InternshipShowCase.css";
import { Internship } from "../../interfaces/InformationInterface";

interface InternshipShowCaseProps {
  internships: Internship[];
  justifyContent?: string;
  onClick?:(intern:Internship)=>any,
}
const idComponent = "internshipIdAnimation";

const InternshipShowCase: FunctionComponent<InternshipShowCaseProps> = (
  props
) => {
  const theme = useTheme();
  const [IsinView, setIsInView] = useState(false);
  const [firstTime, setFirstTime] = useState(true);
  const { internships, justifyContent,onClick } = props;
  useEffect(() => {
    const Obs = new IntersectionObserver(([el]) => {
      //if el not found
      if (!el) return;
      if (el.intersectionRatio > 0) {
        setIsInView(true);
      }
    });
    const el = document.querySelector(`.${idComponent}`);
    if (el) Obs.observe(el);
  });
  const internshipsCmpt = React.useMemo(
    () =>
      internships.map(
        (internship, index) => {
          const { title, miniDescription, url = "", urlIcon } = internship;
          return (
            <Grid
              item
              onClick={()=>onClick?.(internship)}
              key={Math.random()}
              className="card"
              style={{
                animation: IsinView
                  ? `fade-in-intern ${firstTime ? "0.5" : "0"}s forwards ${
                      firstTime ? (index + 1) * 0.1 : 0
                    }s`
                  : "",
              }}
              onAnimationEnd={() => setFirstTime(false)}
            >
              <MiniInternship
                index={index}
                title={title}
                description={miniDescription}
                url={url}
                urlIcon={urlIcon}
                lightMode={theme.palette.mode}
              />
            </Grid>
          );
        }
      ),
    [theme.palette.mode, IsinView]
  );
  return (
    <>
      <Grid
        spacing={1}
        id="InternshipShowCase"
        className={idComponent}
        container
        justifyContent={justifyContent}
      >
        {internshipsCmpt}
      </Grid>
    </>
  );
};

interface MiniInternshipProps {
  title: string;
  description: string;
  url?: string;
  urlIcon?: string;
  lightMode: PaletteMode;
  index: Number;
}

const MiniInternship: FunctionComponent<MiniInternshipProps> = (props) => {
  const {
    title,
    description,
    url = "",
    urlIcon = "",
    lightMode,
    index,
  } = props;

  return (
    <Paper
      elevation={1}
      className="MiniInternshipProps"
      // onClick={() => (window.location.href = `projects?id=${index}`)}
    >
      <Grid container direction={"column"} spacing={0.5}>
        <Grid item>
          <Grid container direction={"row"} gap={1}>
            <Grid item >
              <img
                className="imgIcon"
                referrerPolicy="no-referrer"
                style={{
                  backgroundColor: lightMode === "dark" ? "#f5f5f5" : "none",
                }}
                src={urlIcon}
                alt="icons"
              />
            </Grid>
            <Grid item>
              <Typography className="titleMiniInternship">{title}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Typography variant="body1">{description}</Typography>
        </Grid>
        {url && (
          <Grid
            item
            style={{ color: lightMode === "dark" ? "lightskyblue" : "blue" }}
          >
            <div
              className="linkShowMore"
              onClick={(e) => {
                e.stopPropagation();
                window.open(url);
              }}
            >
              View Website
            </div>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default InternshipShowCase;
